<template>
  <div>
    <navigation/>
    <div class="pale-bgcolor">
      <div class="ay_contain">
        <div class="ay_title">
          亮照注销
        </div>
        <form id="applyForm">
          <input id="siteBaseId" name="siteBaseId" type="hidden">
          <div class="ay_userinfo ay_user">
            <div class="ayui_list">
              <br/>
              <div class="ayui_item">
                <label>网站名称</label>
                <input type="text" name="siteName" id="siteName" disabled v-model="siteBaseInfo.siteName">
              </div>

              <div class="ayui_item">
                <label>企业名称</label>
                <input type="text" id="companyName" name="companyName" disabled v-model="siteBaseInfo.companyName">
              </div>

              <div class="ayui_item">
                <label>网站类型</label>
                <input id="siteType" name="siteType" type="hidden">
                <input v-if="siteBaseInfo.siteType == 1" type="text" value="独立交易网站" disabled>
                <input v-if="siteBaseInfo.siteType == 5" type="text" value="独立非交易网站" disabled>
                <input v-if="siteBaseInfo.siteType == 4" type="text" value="交易平台" disabled>
                <input v-if="siteBaseInfo.siteType == 2" type="text" value="辖区内平台网店" disabled>
                <input v-if="siteBaseInfo.siteType == 3" type="text" value="辖区外平台网店" disabled>
              </div>

              <div class="ayui_item">
                <label><i class="i-sign">∗</i>姓名</label>
                <input type="text" name="personName" id="personName" v-model="param.personName">
                <el-tag type="danger" v-if="personNameMsg != null">{{ personNameMsg }}</el-tag>
              </div>

              <div class="ayui_item">
                <label><i class="i-sign">∗</i>手机号码</label>
                <input type="text" name="phoneNum" id="phoneNum" v-model="param.phone">
                <el-tag type="danger" v-if="phoneMsg != null">{{ phoneMsg }}</el-tag>
              </div>

              <div class="ayui_item ayui_vail" id="getAuthCode">
                <label><i class="i-sign">∗</i>手机验证码</label>
                <input type="text" name="authCode" id="authCode" autocomplete="off" v-model="param.code">
                <span style="cursor:pointer"><a @click="sendPhone" id="sendButton" class="rg-vali-title send_num"
                                                :style="isSend ? 'background-color:#ccc;margin-left: 0px':'background-color:#5289e2;margin-left: 0px'"> <span
                  v-if="isSend" style="background:rgba(0,0,0,0) none repeat scroll !important;">{{
                    downCount
                  }}</span>{{ sendMsg }}</a></span>
                <el-tag type="danger" v-if="codeMsg != null">{{ codeMsg }}</el-tag>
              </div>

              <div class="ayui_item">
                <label><i class="i-sign">∗</i>请输入密码</label>
                <input type="password" name="cipher" readonly style="display:none;">
                <input type="password" name="cipher" id="cipher" autocomplete="off" v-model="param.password">
                <el-tag type="danger" v-if="passwordMsg != null">{{ passwordMsg }}</el-tag>
              </div>

              <div class="ayui_item" style="height: 180px;">
                <label><i class="i-sign">∗</i>注销原因</label>
                <input style="height: 16px;width: 16px;" type="checkbox" v-model="causeType1" name="causeType"
                       value="1">&nbsp;停止网络经营活动或已无法访问
                <el-tag type="danger" v-if="causeTypeMsg != null">{{ causeTypeMsg }}</el-tag>
                <br><label></label>
                <input style="height: 16px;width: 16px;" type="checkbox" v-model="causeType2" name="causeType"
                       value="2">&nbsp;网站(网页)所有权转让
                <br><label></label>
                <input style="height: 16px;width: 16px;" type="checkbox" v-model="causeType3" name="causeType"
                       value="3">&nbsp;网站经营者的营业执照已注销
                <br><label></label>
                <input style="height: 16px;width: 16px;" type="checkbox" v-model="causeType4" name="causeType"
                       value="4">&nbsp;网站经营者域名使用权丧失
                <br><label></label>
                <input class="cause_other" style="height: 16px;width: 16px;" type="checkbox" id="causeType"
                       name="causeType" value="5" @click="causeShow = !causeShow">&nbsp;其他
                <input v-if="causeShow" v-model="param.cause" type="text" name="cause" id="cause" placeholder="请输入原因">
                <el-tag type="danger" v-if="causeMsg != null">{{ causeMsg }}</el-tag>
              </div>

              <div style="clear: both;"></div>
            </div>
          </div>
          <input type="button" id="submitForm" style="width: 120px;margin-left: 420px;" class="rg_botton" value="确定"
                 @click="submit"/>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import navigation from './navigation'

export default {
  name: 'logoutSite',
  components: {
    'navigation': navigation
  },
  data() {
    return {
      causeType1: null,
      causeType2: null,
      causeType3: null,
      causeType4: null,
      otherCause: null,
      causeShow: false,
      siteBaseId: null,
      sendMsg: '发送验证码',
      downCount: 60,
      isSend: false,
      siteBaseInfo: {
        siteName: null,
        siteBaseId: null,
        companyName: null,
        companyType: null,
        companyTypeStr: null
      }, param: {
        code: null,
        password: null,
        relationId: null,
        personName: null,
        phone: null,
        causeType: '',
        cause: null,
      },
      codeMsg: null,
      causeTypeMsg: null,
      passwordMsg: null,
      personNameMsg: null,
      causeMsg: null,
      phoneMsg: null
    }
  },
  watch: {
    $route: function (route) {
      this.dataList(this, 1)
    }
  },
  created: function () {
    this.siteBaseId = parseInt(this.$route.params.siteBaseId)
    this.param.relationId = this.siteBaseId
    this.getSiteBaseInfo(this.siteBaseId)
    let localDate = localStorage.getItem('send_phone')
    if (localDate != null) {
      let timeCount = ((Date.now() - localDate) / 1000).toFixed(0)
      if (timeCount < 60) {
        this.isSend = true
        this.downCount = 60 - timeCount
        var interval = null
        interval = setInterval(() => {
          this.downCount = this.downCount - 1
          if (this.downCount <= 0) {
            if (interval != undefined && interval != null) {
              clearInterval(interval);
            }
            this.sendMsg = '发送验证码'
            this.isSend = false
          }
        }, 1000)
      }
    }
  },
  methods: {
    checkInput() {
      let flag = true
      if (this.param.personName == null || this.param.personName == '') {
        this.personNameMsg = '请输入姓名!'
        flag = false
      } else {
        this.personNameMsg = null
      }
      if (this.param.phone == null || this.param.phone == '') {
        this.phoneMsg = '请输入手机号!'
        flag = false
      } else {
        this.phoneMsg = null
      }
      if (this.param.code == null || this.param.code == '') {
        this.codeMsg = '请输入验证码!'
        flag = false
      } else {
        this.codeMsg = null
      }
      if (this.param.password == null || this.param.password == '') {
        this.passwordMsg = '请输入密码!'
        flag = false
      } else {
        this.passwordMsg = null
      }
      if (this.causeShow == false && this.causeType4 != true && this.causeType1 != true && this.causeType2 != true && this.causeType3 != true) {
        this.causeTypeMsg = '请选择原因!'
        flag = false
      } else {
        this.causeTypeMsg = null
      }
      if (this.causeShow == true && (this.param.cause == null || this.param.cause === '')) {
        this.causeMsg = '请输入其他原因!'
        flag = false
      } else {
        this.causeMsg = null
      }
      return flag
    },
    /**
     * 点击发送验证码
     */
    sendPhone() {
      if (this.param.phone == null) {
        this.$message.warning('请填写手机号!')
        return
      }
      var reg = /^1\d{10}$/
      if (!reg.test(this.param.phone)) {
        this.$message.warning('手机号格式错误, 无法发送!')
        return
      }
      if (this.isSend) {
        return
      }
      localStorage.setItem('send_phone', Date.now())
      let _self = this
      _self.axios.get(
        _self.api.sendPhoneCode + '?phone=' + this.param.phone
      ).then(res => {
        if (res.data.code === 10001) {
          this.toIndex()
        } else if (res.data.code === 10000) {
          this.$message.success('发送成功!')
          this.isSend = true
          this.downCount = 60
          this.sendMsg = '秒后重试'
          var interval = null
          interval = setInterval(() => {
            this.downCount = this.downCount - 1
            if (this.downCount <= 0) {
              if (interval != undefined) {
                clearInterval(interval);
              }
              this.sendMsg = '发送验证码'
              this.isSend = false
            }
          }, 1000)
        } else {
          this.$message.error(res.data.message)
        }
      }).catch(err => {
        this.$message.error('网络请求异常!')
      })
    },
    submit() {
      if (!this.checkInput()) {
        return
      }
      var reg = /^1\d{10}$/
      if (this.param.phone != null && this.param.phone !== '' && !reg.test(this.param.phone)) {
        this.$message.warning('手机号格式错误!')
        return
      }
      if (this.param.code == null) {
        this.$message.warning('请填写验证码!')
        return
      }
      let _self = this
      this.param.causeType = null
      if (this.causeType1) {
        this.param.causeType = '1'
      }
      if (this.causeType2) {
        this.param.causeType += '2'
      }
      if (this.causeType3) {
        this.param.causeType += '3'
      }
      if (this.causeType4) {
        this.param.causeType += '4'
      }
      if (this.causeShow == true) {
        this.param.causeType += '5'
      }
      _self.axios.post(
        _self.api.logoutApply, this.param
      ).then(res => {
        if ((typeof res) === 'string') {
          res = JSON.parse(res)
        }
        if (res.data.code === 10001) {
          this.toIndex()
        } else if (res.data.code !== 10000) {
          this.$message.error(res.data.message)
        } else {
          this.$message.success(res.data.message)
          this.$router.go(-1)
        }
      }).catch(err => {
        this.$message.error('网络请求异常!')
      })
    },
    getSiteBaseInfo(siteBaseId) {
      let _self = this
      _self.axios.get(
        _self.api.getSiteBaseInfoById + siteBaseId,
      ).then(res => {
        if (res.data.code === 10001) {
          this.toIndex()
        }
        this.siteBaseInfo = res.data.obj
      }).catch(err => {
        this.$message.error('网络请求异常!')
      })
    },
    toIndex() {
      this.$router.push({
        path: '/index'
      })
    }
  }
}
</script>

<style>
@import '../assets/css/iconfont.css';
@import '../assets/css/aicUser.css';
@import '../assets/css/newStyle.css';
@import '../assets/css/highlight.css';
@import '../assets/css/paging.css';
@import '../assets/css/bright.css';

#applyStatus .li {
  background: rgba(0, 0, 0, 0) none repeat scroll !important;
}

.i-sign {
  margin-right: 3px;
}

</style>




// WEBPACK FOOTER //
// src/components/logoutSite.vue